
<template>
  <div class="layout" style="height: 100%;">
      <!--导航-->
        <div hide-trigger :style="{background: '#fff'}" class="navleft">
          <Menu active-name theme="light" width="auto" :open-names="['1']" accordion>
            <Submenu v-for="(item, index) in navList"  :name="index" :key="index">
              <template slot="title">{{item.name}}</template>
               <MenuItem :name="index+'-'+(n+1)" v-for="(m, n) in item.sysMenus"  @click.native="gonav(m)" :key="n">
                   <img src="../assets/img/blue.jpg" class="navimg" v-if="m.IMG==1" >
                   <img src="../assets/img/yellow.jpg" class="navimg" v-if="m.IMG==0">
                  <span> {{m.name}}</span>
               </MenuItem>
            </Submenu>
          </Menu>
        </div>
        <div style="width: 100%; height: 100%;padding: 70px 24px 0px 300px;overflow: auto">
          <Breadcrumb :style="{margin: '24px 0'}">
            <Icon type="ios-home" class="icon-breadcrumb" />当前位置：
            <Breadcrumb style="display: inline-block">
               <BreadcrumbItem to="/main">{{shopName}}</BreadcrumbItem>
               <BreadcrumbItem to="/content">首页</BreadcrumbItem>
               <BreadcrumbItem v-for="(item,index) in BreadcrumbList" :key="index" :to="item.path">
                   {{item.name}}
               </BreadcrumbItem> 
            </Breadcrumb>
          </Breadcrumb>
          <div style="background: #ffffff;padding: 24px;">
            <router-view />
          </div>
        </div>


        <div  class="thumbnail"  :class="{'fadeLeave':isleft}" >
            <img  src="../assets/img/thumbnail.png" @click="ishowbigImg">
            <span style="text-align: right;position: relative; top: -30px; left: 360px" @click="closebigg" >关闭</span>
        </div>


      <Modal
              footer-hide
              :mask-closable="false"
              @on-cancel="cancelclose"
              v-model="Advertisement"
              title="提醒"
              width="70%">
          <img src="../assets/img/pcgg.png" width="100%" >
      </Modal>

  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      navList: [],
      BreadcrumbList: [],
      shopName: "",
      Advertisement: false,

      /*黄钻*/
      yellow: [
        "采购报表",
        "盘点报表",
        "销售报表",
        "营收报表",
        "记一笔",
        "记一笔历史",
        "记一笔明细",
        "库存预警",
        "库存流水",
        "草稿单",
        "库存调拨",
        "调拨历史",
        "调拨报表",
        "热销商品",
        "今日结余",
        "员工管理",
        "复制商品",
        "角色管理"
      ],
      blue: [
        "客户分析",
        "供应商分析",
        "会员储值",
        "分享服务",
        "会员积分",
        "员工业绩",
        "店铺客户充值记录",
        "客户对账",
        "供应商对账",
        "经营概况"
      ],

      isleft: false
    };
  },

  watch: {
    $route(to, from) {
      // 监听路由变化
      var isFlag = true;
      for (var i = 0; i < this.BreadcrumbList.length; i++) {
        if (this.BreadcrumbList[i].path == to.path) {
          this.BreadcrumbList = this.BreadcrumbList.splice(
            i,
            this.BreadcrumbList.length - 1
          );
          isFlag = false;
          break;
        }
      }
      if (to.path == "/content") {
        this.BreadcrumbList = [];
      }
      if (isFlag && to.path != "/content") {
        this.BreadcrumbList.push({
          name: to.name,
          path: to.path
        });
      }
    }
  },
  mounted() {
    // 刷新时
    //this.BreadcrumbList = this.$route.matched
  },
  

  created: function(){
    //修改路由的meta值，把缓存关掉，然后在缓存页面中再打开

    //获取用户信息
    console.log("---")
    var userId = JSON.parse(localStorage.getItem("adminUser"));
    var cid = JSON.parse(localStorage.getItem("adminUser")).cid;
    var sid = JSON.parse(localStorage.getItem("adminUser")).id;
    if (userId.type == 1) {
      
      var id = JSON.parse(localStorage.getItem("shop")).id;
    } else {
      var id = JSON.parse(localStorage.getItem("adminUser")).sid;
    }
    this.getisNotPrintlist(cid, id);//获取打印信息
    this.getSysMenuCategory(userId, id);//获得菜单信息

    /**
     * 返回100058 是开通9.9了
     **/
    setTimeout(() => {
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");
      if (
        shopArray.indexOf("100058") > -1 ||
        shopArray.indexOf("100055") > -1
      ) {
        //不包含10058，打开广告弹框
      } else {
        const spaceTime = JSON.parse(sessionStorage.getItem("spaceTime"));
        setInterval(() => {
          this.isleft = true;
        }, spaceTime * 1000);
      }
    }, 500);
    //监听键盘
    document.addEventListener('keydown', this.handleKeyDown);
  },
  destroyed() {
   document.removeEventListener('keydown', this.handleKeyDown);//清除绑定的
  },    
  methods: {
    //监听键盘事件
    handleKeyDown(e) {
      var key = window.event.keyCode ? window.event.keyCode : window.event.which
      //F1跳转销售开单页面
      // alert(key);
      if( key == this.constant.skF1 ){
        this.navList.forEach((item,list)=>{
          item.sysMenus.forEach((m,k)=>{
            if(m.url == '/newsale'){
              this.gonav(m);
            }
          });
        });
        e.preventDefault() //取消浏览器原有的当前快捷键操作
      }
    },      
    /*点击小广告显示大广告*/
    ishowbigImg() {
      this.Advertisement = true;
    },
    /*关闭大广告*/
    cancelclose() {
      this.isleft = false;
    },
    /*关闭小广告*/
    closebigg() {
      this.isleft = false;
    },

    /*获取当前店铺名字*/
    getisNotPrintlist(cid, id) {
      
      this.$Api
        .getisNotPrintlist({
          cid: cid,
          id: id
        })
        .then(res => {
          if (res.code == 200) {
            this.shopName = res.data.name;
            localStorage.setItem("shop", JSON.stringify(res.data));
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //导航
    getSysMenuCategory(userId, id) {
      this.$Api
        .getSysMenuCategory({
          adminId: userId.id,
          sid: id,
          systemInfo: "iOS_4.2.0"
        })
        .then(res => {
          if (res.code == 200) {
            res.data.forEach(item => {
              item.sysMenus.forEach(m => {
                this.yellow.forEach(t => {
                  if (m.name == t) {
                    m.IMG = 0;
                  }
                });
                this.blue.forEach(t => {
                  if (m.name == t) {
                    m.IMG = 1;
                  }
                });
              });
            });

            this.navList = res.data;
            
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //跳转导航之前
    gonav(data) {
      
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");

      //100051皇冠  100060蓝钻 100059黄钻
      if (data.IMG == 0) {
        //黄钻
        if (
          shopArray.indexOf("100059") > -1 ||
          shopArray.indexOf("100051") > -1 ||
          shopArray.indexOf("100060") > -1
        ) {
        } else {
          this.$Message.warning("亲,你还未购买此服务，暂时不能访问!");
          return;
        }
      } else if (data.IMG == 1) {
        //蓝钻
        if (
          shopArray.indexOf("100060") > -1 ||
          shopArray.indexOf("100051") > -1
        ) {
        } else {
          this.$Message.warning("亲,你还未购买此服务，暂时不能访问!");
          return;
        }
      }

      /***
       * 判断是否开通总仓管理
       * */
      var isopen = JSON.parse(localStorage.getItem("shop")).isopen;
      if (
        (isopen == 1 && data.url == "/addpurc") ||
        (isopen == 1 && data.url == "/purchasea-tui") ||
        (isopen == 1 && data.url == "/history") ||
        (isopen == 1 && data.url == "/history-tui")
      ) {
        this.$Message.info("当前店铺总仓管控，不可进行此操作");
        return;
      }

      var flag = 0;
      this.navList.forEach(item => {
        item.sysMenus.forEach(m => {
          if (m.status == 0 && data.id == m.id) {
            flag = 1;
            this.$Message.warning("暂无权限访问");
            return;
          }
        });
      });
      if (flag == 1) {
        return;
      }
      var localisreg = localStorage.getItem("registerShop");
      if (data.url == "/newonOrdowngoods" || data.url == "/order") {
        if (localisreg == 1) {
          this.$Message.warning("请先注册");
          this.$router.push({ path: "/shopmanage" });
          return;
        } else {
          this.$router.push({ path: data.url });
        }
      } else {
        this.$router.push({ path: data.url });
      }
      this.BreadcrumbList = [];
      this.BreadcrumbList.push(
        {
          name: data.classifyname,
          path: ""
        },
        {
          name: data.name,
          path: data.url
        }
      );
    },


    goPages() {
      this.$router.push({ path: "/PurchasingBill" });
    },
    bossIndex() {
      this.$router.push({ path: "/bossIndex" });
    }
  }
};
</script>


<style scoped>
.fadeLeave {
  transition: all 5s ease;
  left: 50% !important;
}
.navleft {
  width: 280px;
  height: 100%;
  position: absolute;
  padding-top: 80px;
}
.navleft > ul {
  height: 100%;
  overflow: auto;
}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo {
  width: 200px;
  height: 30px;
  float: left;
  position: relative;
  top: 0px;
  left: 20px;
  font-size: 28px;
  color: #fefeff;
  font-family: AdobeHeitiStd-Regular;
}
.layout-nav {
  width: 420px;
  margin: 0 auto;
  margin-right: 20px;
}
#create-outline {
  border-left: rgba(255, 255, 255, 0.2) 1px solid;
  border-right: rgba(255, 255, 255, 0.2) 1px solid;
}
.layout {
  border: 0;
  border-radius: 0;
}
.ivu-layout-header {
  background: #2d8cf0;
  padding: 0;
  padding-right: 50px;
  height: 70px;
}
.ivu-menu-horizontal {
  height: 70px;
  line-height: 70px;
}
.ivu-menu-item {
  padding: 0 16px;
}
.icon-msg {
  font-size: 20px;
}
.main_content {
  background: #ffffff;

  padding: 24px 24px 0px;
}
.navimg {
  position: absolute;
  left: 22px;
  top: 12px;
  width: 20px;
}
.thumbnail {
  position: absolute;
  top: 20%;
  width: 400px;
  z-index: 1000;
  left: 150%;
  margin-left: -200px;
  cursor: pointer;
}
.thumbnail img {
  width: 100%;
}
</style>